// extracted by mini-css-extract-plugin
export default {"NewFloorForm":"NewFloorForm_NewFloorForm__JPF-K","brochurePreview":"NewFloorForm_brochurePreview__d6pts"};